import {AlertModel} from 'shared/models/AlertModel';
import {
  ADD_ALERT,
  CommonActionTypes,
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HEADER_HEIGHT,
  HIDE_MESSAGE,
  REDIRECT_TO,
  REMOVE_ALERT,
  SHOW_MESSAGE,
  TOGGLE_APP_DRAWER,
} from './CommonAction';

export const addAlert = (payload: AlertModel): CommonActionTypes => ({
  type: ADD_ALERT,
  payload,
});

export const removeAlert = (payload: string): CommonActionTypes => ({
  type: REMOVE_ALERT,
  payload,
});
export const fetchStart = (fetchId: string): CommonActionTypes => ({
  type: FETCH_START,
  fetchId,
});

export const fetchSuccess = (fetchId: string): CommonActionTypes => ({
  type: FETCH_SUCCESS,
  fetchId,
});

export const fetchError = (fetchId: string, error: string, redirectTo?: string): CommonActionTypes => ({
  type: FETCH_ERROR,
  error,
  redirectTo,
  fetchId,
});

export const showMessage = (message: string, redirectTo?: string): CommonActionTypes => ({
  type: SHOW_MESSAGE,
  message,
  redirectTo,
});

export const redirectTo = (redirectTo: string): CommonActionTypes => ({
  type: REDIRECT_TO,
  redirectTo,
});

export const onToggleAppDrawer = (): CommonActionTypes => ({
  type: TOGGLE_APP_DRAWER,
});

export const setHeaderHeight = (value: number): CommonActionTypes => ({
  type: HEADER_HEIGHT,
  value: value,
});

export const hideMessage = (): CommonActionTypes => ({type: HIDE_MESSAGE});
